import axiosService from "common/axiosService";
import { API_URL } from "common/defines";

export const upload = async (data) => {
    return await axiosService.post(API_URL + "/public-upload", data);
};
